import { type Clip } from '@air/api/types';

import { useViewsSelectAllStore } from '~/components/v2/store/features/views/useViewsSelectAllStore';
import { selectedClipItemsSelector } from '~/store/selectedItems/selectors';
import { type useAirStore } from '~/utils/ReduxUtils';

export type WorkspaceAgentExplicitClipSelection = {
  clips: Clip[];
  hasExplicitClipSelection: boolean;
};

export const getWorkspaceAgentExplicitClipSelectionFromStore = (
  store: ReturnType<typeof useAirStore>,
): WorkspaceAgentExplicitClipSelection => {
  const selectAll = useViewsSelectAllStore.getState().selectAll;

  if (selectAll) {
    return { clips: [], hasExplicitClipSelection: false };
  }

  const selectedClipItems = selectedClipItemsSelector(store.getState());

  if (selectedClipItems.length === 0) {
    return { clips: [], hasExplicitClipSelection: false };
  }

  const clips = selectedClipItems.map((selected) => selected.item);

  return { clips, hasExplicitClipSelection: true };
};
